// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__He-OH","label":"styles_label__3Z3mk"};